var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card-actions',[_c('v-btn',{staticClass:"mr-2",attrs:{"large":"","text":"","color":"primary"},on:{"click":function($event){return _vm.$emit('clear')}}},[_vm._v("Limpar")]),_c('v-spacer'),_c('v-btn',{attrs:{"large":"","color":"primary"},on:{"click":function($event){return _vm.$emit('submit')}}},[_vm._v("Enviar")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }